import React from 'react';
import {
  Box, Container, Typography, Button, Paper,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

interface LegalPageLayoutProps {
  title: string;
  lastUpdated?: string;
  children: React.ReactNode;
}

export default function LegalPageLayout({ title, lastUpdated, children }: LegalPageLayoutProps) {
  return (
    <Box
      component="article"
      sx={{
        minHeight: '100vh',
        pt: { xs: 10, md: 12 },
        pb: { xs: 6, md: 10 },
        background: 'linear-gradient(180deg, #f8fafc 0%, #ffffff 40%)',
      }}
    >
      <Container maxWidth="md">
        <Button
          component={RouterLink}
          to="/"
          startIcon={<ArrowBack />}
          sx={{ mb: 2, color: 'text.secondary' }}
        >
          Voltar ao início
        </Button>
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontSize: { xs: '1.75rem', md: '2.25rem' },
            fontWeight: 800,
            color: '#0f172a',
            mb: 1,
          }}
        >
          {title}
        </Typography>
        {lastUpdated && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Última atualização: {lastUpdated}
          </Typography>
        )}
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 4 },
            borderRadius: 3,
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Box
            sx={{
              color: 'text.primary',
              '& h2': {
                fontSize: '1.15rem',
                fontWeight: 700,
                mt: 3,
                mb: 1.5,
                '&:first-of-type': { mt: 0 },
              },
              '& p': { mb: 2, lineHeight: 1.75, fontSize: '0.95rem' },
              '& ul': { pl: 2.5, mb: 2 },
              '& li': { mb: 0.75, lineHeight: 1.7, fontSize: '0.95rem' },
            }}
          >
            {children}
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
